import { createEvent } from "effector";
import { $audioManager } from "./audioManager";

export const mute = createEvent();
export const unmute = createEvent();

$audioManager.on(mute, (state) => ({ ...state, muted: true }));
$audioManager.on(unmute, (state) => ({ ...state, muted: false }));
